// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import '@/styles/index.scss'
import i18n from '@/utils/i18n'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill';
// const i18n = new VueI18n({
//   locale: localStorage.getItem('lang','zh'),    // 语言标识
//   messages: {
//       'zh': require('./common/lang/zh'),
//       'en': require('./common/lang/en')
//   }
// })
import animated from 'animate.css' // npm install animate.css --save安装，在引入

Vue.use(animated)
Vue.config.productionTip = false;

//Interactive axios
import axios from 'axios';
// axios.defaults.withCredentials=true;           // carry the certificate
Vue.prototype.axios = axios; //Prototype binding axios

import HttpService from './service/HttpService'; //Introduce axios configuration
Vue.prototype.$http = HttpService; //Prototype binding

Vue.prototype.oAssets = process.env.BASE_IMG;

//state management
import store from './store';

Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: {
    App
  },
  template: '<App/>',
  store,
})



// WEBPACK FOOTER //
// ./src/main.js